module.exports = __webpack_public_path__ + "static/full-logo-dark-bbb25f434c854930f3966bf787d90d78.png";